import React from 'react';

import { FeeLineProps } from './types';
import styles from './styles.module.css';

const generateDataTestId = (label: string) =>
  `fee-line-${label.toLowerCase().replace(/\s+/g, '-')}`;

export const FeeLine: React.FC<FeeLineProps> = ({ label, value, altValue }) => (
  <div
    data-testid={generateDataTestId(label)}
    className={styles.feeLineContainer}
  >
    <span className={styles.feeLineLabel}>{label}</span>

    <span className={styles.feeLineValueContainer}>
      <span className={styles.feeLineValue}>{value}</span>

      {altValue && <span className={styles.feeLineAltValue}>{altValue}</span>}
    </span>
  </div>
);
